import React, { useState } from 'react'

import { Modal, ModalButtons, CheckBoxInput, Button } from '@pb/components'
import { consoleEvents, showCopyKeys } from '@pb/utils'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { skipRenderOnError } from 'hocs/ErrorBoundary'

import { USER_CLUB_JOIN_STATUS } from '../constants'
import { operationToggleLoaders } from '../duck/operations'
import appSelectors from '../duck/selectors'
import styles from './DevToolbar.scss'

const DevToolbar: React.FC<any> = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [showLabelKeys] = useState(showCopyKeys())
  const opToggleLabels = (): any => {
    if (!showLabelKeys) {
      window.history.pushState({}, document.title, '?showkeys=true')
    } else {
      window.history.pushState({}, document.title, window.location.pathname)
    }
    window.location.reload()
  }

  const handleCustomerTypeChange = (e): any => {
    localStorage.removeItem('hmCustomerType')

    consoleEvents.info('Setting customerType to:', e.target.value)

    setTimeout(() => {
      consoleEvents.info('Wait...')
    }, 300)

    localStorage.setItem('hmCustomerType', e.target.value)

    setTimeout(() => {
      window.location.reload()
    }, 1000)
  }

  const handleErrorChange = (e): any => {
    localStorage.removeItem('hmError')

    consoleEvents.info('Setting error to:', e.target.value)

    setTimeout(() => {
      consoleEvents.info('Wait...')
    }, 300)

    localStorage.setItem('hmError', e.target.value)

    setTimeout(() => {
      window.location.reload()
    }, 1000)
  }

  const handleUserStatusSelectChange = (e): any => {
    localStorage.removeItem('hmUserStatus')

    consoleEvents.info('Setting user status to:', e.target.value)

    setTimeout(() => {
      consoleEvents.info('Wait...')
    }, 300)

    localStorage.setItem('hmUserStatus', e.target.value)

    setTimeout(() => {
      window.location.reload()
    }, 1000)
  }

  const handleClearButton = (): any => {
    localStorage.removeItem('hmClubApiUrl')
    localStorage.removeItem('hmClubAdobeApiUrl')
    localStorage.removeItem('hmUserStatus')
    localStorage.removeItem('hmCustomerType')
    localStorage.removeItem('hmError')

    consoleEvents.info('Clearing dev settings in localStorage.')

    setTimeout(() => {
      consoleEvents.info('Wait...')
    }, 300)

    setTimeout(() => {
      window.location.reload()
    }, 1000)
  }

  const handleToggleMenu = (isOpen): any => {
    setIsMenuOpen(isOpen)
  }

  const { showLoaders, opToggleLoaders } = props

  if (!__DEMO_OR_DEV__) {
    return null
  }

  return (
    <aside aria-label="Development Tools">
      <button
        type="button"
        className={`${styles.toggleButton} ${isMenuOpen ? styles.isOpen : ''}`}
        onClick={() => handleToggleMenu(true)}
        aria-label="Trigger Development Tools"
      >
        <svg viewBox="0 0 569 569.549" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.527 52.246l37.985 66.469a9.488 9.488 0 0 0 5.933 4.5l35.438 8.86 121.543 121.542 13.43-13.426L92.41 116.75a9.47 9.47 0 0 0-4.406-2.5l-34.05-8.543-32.34-56.625L49.34 21.355l56.648 32.372 8.547 34.05a9.47 9.47 0 0 0 2.496 4.414l123.446 123.446 13.425-13.43L132.36 80.664 123.5 45.246a9.511 9.511 0 0 0-4.5-5.945L52.527 1.32a9.496 9.496 0 0 0-11.394 1.527L3.153 40.832a9.495 9.495 0 0 0-1.626 11.414zm394.785 134.899L187.41 396.05l-13.43-13.43L382.887 173.72zM150.849 403.44a9.493 9.493 0 0 0-8.141-4.605H85.734a9.486 9.486 0 0 0-8.136 4.605l-28.489 47.477a9.495 9.495 0 0 0 0 9.781l28.489 47.477a9.495 9.495 0 0 0 8.136 4.605h56.973a9.501 9.501 0 0 0 8.14-4.605l28.485-47.477a9.495 9.495 0 0 0 0-9.781zm-13.512 90.348H91.109L68.32 455.81l22.79-37.985h46.226l22.789 37.985zm0 0" />
          <path d="M456.063 227.914c62.714.211 113.73-50.46 113.94-113.176a113.589 113.589 0 0 0-3.487-28.308c-1.266-5.09-6.418-8.188-11.508-6.922a9.522 9.522 0 0 0-4.414 2.496l-59.11 59.07-46.898-15.629-15.64-46.886 59.109-59.121a9.495 9.495 0 0 0-4.453-15.934c-60.82-15.402-122.606 21.414-138.008 82.23a113.327 113.327 0 0 0-3.477 28.23c.024 7.477.793 14.93 2.309 22.25L136.469 344.169a112.023 112.023 0 0 0-22.246-2.309C51.289 341.86.273 392.875.273 455.81c0 62.93 51.016 113.945 113.95 113.945 62.93 0 113.945-51.016 113.945-113.945a111.742 111.742 0 0 0-2.309-22.25l49.786-49.786 21.773 21.774a9.499 9.499 0 0 0 13.43 0l4.746-4.75c4.164-4.137 10.894-4.137 15.058 0 4.16 4.148 4.168 10.883.02 15.043l-.02.02-4.746 4.745c-3.707 3.708-3.707 9.72 0 13.426L439.18 547.305c29.793 30.066 78.316 30.285 108.383.492 30.062-29.793 30.28-78.32.488-108.383-.16-.164-.324-.328-.489-.492L434.29 325.652c-3.707-3.707-9.719-3.707-13.426 0l-4.746 4.746c-4.168 4.141-10.894 4.141-15.062 0-4.157-4.148-4.168-10.882-.02-15.039.008-.007.016-.011.02-.02l4.75-4.75c3.707-3.706 3.707-9.718 0-13.425l-21.774-21.773 49.785-49.786a111.733 111.733 0 0 0 22.247 2.31zm37.308 322.852a57.7 57.7 0 0 1-20.195-3.684l74.16-74.164c11.191 29.77-3.867 62.973-33.637 74.164a57.6 57.6 0 0 1-20.328 3.684zM385.797 303.973c-10.516 12.543-8.867 31.238 3.676 41.75 11.023 9.238 27.09 9.23 38.101-.028l106.563 106.657c1.156 1.16 2.238 2.382 3.285 3.625l-81.188 81.187a55.28 55.28 0 0 1-3.629-3.285L345.961 427.227c10.516-12.543 8.867-31.239-3.676-41.75-11.023-9.243-27.094-9.23-38.105.023l-15.192-15.191 81.614-81.493zm38.344-95.504L208.73 423.836a9.51 9.51 0 0 0-2.508 9.023c13.027 51.16-17.887 103.196-69.051 116.22-51.16 13.026-103.195-17.888-116.223-69.052-13.023-51.16 17.89-103.195 69.055-116.222a95.649 95.649 0 0 1 47.168 0 9.58 9.58 0 0 0 9.023-2.504l215.36-215.371a9.49 9.49 0 0 0 2.496-9.02c-12.938-50.562 17.562-102.039 68.125-114.98a94.55 94.55 0 0 1 29.281-2.766l-50.09 50.11a9.487 9.487 0 0 0-2.297 9.71l18.989 56.977a9.504 9.504 0 0 0 6.011 6l56.977 18.992a9.496 9.496 0 0 0 9.71-2.289l50.09-50.09a86.32 86.32 0 0 1 .173 5.39c.265 52.177-41.813 94.688-93.989 94.958a94.602 94.602 0 0 1-23.918-2.953 9.504 9.504 0 0 0-9.023 2.496h.05zm0 0" />
          <path d="M491.273 477.578l-13.43 13.43-94.952-94.953 13.425-13.43zm0 0" />
        </svg>
      </button>

      <Modal
        closeButtonText="Close"
        title="Dev settings"
        isOpen={isMenuOpen}
        toggleModal={() => handleToggleMenu(false)}
        className={styles.modalContent}
      >
        <CheckBoxInput
          checked={showLabelKeys}
          onChange={opToggleLabels}
          name="labelKeys"
          label="Label keys"
          shouldShowValidationIcon={false}
        />
        <CheckBoxInput
          checked={showLoaders}
          onChange={opToggleLoaders}
          name="loaders"
          label="Show loaders"
          shouldShowValidationIcon={false}
        />
        <div className={styles.userStatus}>
          <label className={styles.userStatusLabel} htmlFor="userstatus">
            User status:
          </label>
          <select
            id="userstatus"
            onChange={handleUserStatusSelectChange}
            name="userstatus"
            defaultValue={localStorage.getItem('hmUserStatus') || 'none'}
          >
            <option disabled value="none">
              Select one...
            </option>
            {Object.keys(USER_CLUB_JOIN_STATUS).map((status) => {
              return (
                <option key={status} value={status}>
                  {status}
                </option>
              )
            })}
          </select>
        </div>
        <div className={styles.userStatus}>
          <label className={styles.userStatusLabel} htmlFor="errorType">
            error:
          </label>
          <select
            id="errorType"
            onChange={handleErrorChange}
            name="errorType"
            defaultValue={localStorage.getItem('hmError') || 'none'}
          >
            <option disabled value="none">
              Select one...
            </option>
            <option value="sberbank=none">SBERBANK - no error</option>
            <option value="sberbank=0">SBERBANK - invalid data</option>
            <option value="sberbank=1">SBERBANK - transaction denied</option>
            <option value="sberbank=2">SBERBANK - transaction denied TP1</option>
            <option value="none">NONE</option>
          </select>
        </div>
        <div className={styles.userStatus}>
          <label className={styles.userStatusLabel} htmlFor="customertype">
            customerType:
          </label>
          <select
            id="customertype"
            onChange={handleCustomerTypeChange}
            name="customertype"
            defaultValue={localStorage.getItem('hmCustomerType') || 'none'}
          >
            <option disabled value="none">
              Select one...
            </option>
            <option value="REGISTERED">REGISTERED</option>
            <option value="TEMPORARY">TEMPORARY</option>
            <option value="GUEST">GUEST</option>
            <option value="UNAUTHORIZED">UNAUTHORIZED</option>
          </select>
        </div>
        <ModalButtons bottom fullWidth>
          <Button onClick={handleClearButton} fullWidth>
            Clear all settings
          </Button>
        </ModalButtons>
      </Modal>
    </aside>
  )
}

DevToolbar.propTypes = {
  showLoaders: PropTypes.bool,
  opToggleLoaders: PropTypes.func,
}

const mapStateToProps = (state): any => {
  const showLoaders = appSelectors.getShowLoaders(state)

  return {
    showLoaders,
  }
}

const mapDispatchToProps = (dispatch): any => {
  const opToggleLoaders = (): any => dispatch(operationToggleLoaders())

  return {
    opToggleLoaders,
  }
}

export default skipRenderOnError(connect(mapStateToProps, mapDispatchToProps)(DevToolbar))
